/* Topics view: cards or a table, ported from artifact-v2.html.
   Every card uses the same accent colour on purpose \u2014 colour would imply a ranking that
   does not exist. Cards now list the top queries in each topic; the table view puts the
   same topics side by side for comparison. Both filter the query table on click. */

import { $, esc, fmt } from "../util.js";
import { paintIcons } from "../icons.js";
import { TCOLORS } from "../colors.js";

let topicView = "cards";

export function initTopicToggle(onSwitch) {
  document.querySelectorAll("#tv-toggle button").forEach(b => b.addEventListener("click", () => {
    document.querySelectorAll("#tv-toggle button").forEach(x => x.classList.remove("on"));
    b.classList.add("on");
    topicView = b.dataset.v;
    applyTopicView();
    onSwitch?.();
  }));
}

function applyTopicView() {
  $("topic-cards").classList.toggle("hidden", topicView !== "cards");
  $("topic-table-card").classList.toggle("hidden", topicView !== "table");
}

export function renderTopics(groups, ctx) {
  $("topic-note").textContent = (ctx.isDemo
    ? "Demo topics come from the synthetic dataset. "
    : "Topics are inferred from query tokens — best-effort. ") + "Click a topic to see its queries.";

  const [c, soft] = TCOLORS[0];

  $("topic-cards").innerHTML = groups.map(t => {
    const share = t.share || 0;
    const top = (t.topQueries || []).slice(0, 5);
    return '<div class="acard" data-tc="' + esc(t.value) + '" style="cursor:pointer;position:relative;overflow:hidden">' +
      '<span style="position:absolute;top:0;left:0;right:0;height:3px;background:' + c + '"></span>' +
      '<div style="display:flex;justify-content:space-between;align-items:center"><div class="ah"><i data-ic="layers" style="color:' + c + '"></i>' + esc(t.value) + "</div>" +
      '<span class="pill" style="color:' + c + ";background:" + soft + ';font-weight:600">' + share.toFixed(0) + "% conv</span></div>" +
      '<div class="am"><span><b>' + fmt(t.n) + "</b> queries</span><span><b>" + fmt(t.imp) + "</b> impr</span><span>avg pos <b>" + t.pos.toFixed(1) + "</b></span></div>" +
      '<div class="btrack" style="height:7px"><div class="bfill" style="width:' + Math.min(share, 100) + "%;background:" + c + '"></div></div>' +
      (top.length ? '<div class="tql">' + top.map(q =>
        '<div class="tqr"><span class="tq" title="' + esc(q.q) + '">' + esc(q.q) + '</span><span class="ti">' + fmt(q.imp) + " im</span></div>").join("") + "</div>" : "") +
      '<span class="abtn"><i data-ic="table"></i>view queries</span></div>';
  }).join("");

  $("topic-table").innerHTML =
    "<thead><tr><th>Topic</th><th class='num'>Queries</th><th class='num'>Conversational</th><th class='num'>Conv share</th>" +
    "<th class='num'>Impressions</th><th class='num'>Clicks</th><th class='num'>Avg pos</th><th>Top query</th></tr></thead><tbody>" +
    groups.map(t => {
      const share = t.share || 0;
      const [sc, sb] = share >= 30 ? ["var(--magenta)", "var(--magenta-soft)"]
        : share >= 15 ? ["var(--violet)", "var(--violet-soft)"]
        : ["var(--sub)", "var(--chip)"];
      const topQ = (t.topQueries || [])[0];
      return '<tr class="r" data-tt="' + esc(t.value) + '"><td class="tname">' + esc(t.value) + "</td>" +
        '<td class="mono num">' + fmt(t.n) + "</td>" +
        '<td class="mono num">' + fmt(t.conv || 0) + "</td>" +
        '<td class="num"><span class="pill" style="color:' + sc + ";background:" + sb + '">' + share.toFixed(0) + "%</span></td>" +
        '<td class="mono num">' + fmt(t.imp) + "</td>" +
        '<td class="mono num">' + fmt(t.clicks || 0) + "</td>" +
        '<td class="mono num">' + t.pos.toFixed(1) + "</td>" +
        '<td class="dim tquery" title="' + esc(topQ ? topQ.q : "") + '">' + esc(topQ ? topQ.q : "—") + "</td></tr>";
    }).join("") + "</tbody>";

  applyTopicView();
  paintIcons($("topic-cards"));
  document.querySelectorAll("[data-tc],[data-tt]").forEach(el =>
    el.addEventListener("click", () => ctx.onFilter({ topic: el.dataset.tc || el.dataset.tt })));
}
